module.exports = __webpack_public_path__ + "static_official_spa/img/contact.97af2b57.png";